import React from "react";
import Image from 'react-bootstrap/Image';
// import MaterialIcon from 'react-google-material-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

function PasswordChanged({onclickBackToLogin}) {
    return (
        <div className="col-xxl-4 col-lg-5 col-md-7">
            <div className="card">
                <div className="card-header pt-4 pb-4 text-center">
                    <span><Image src="/img/ta-securities-logo.png" style={{height: "55px", width: "auto"}}/></span>
                </div>
                <div className="card-body">
                    <div className="text-center w-75 m-auto">
                        <FontAwesomeIcon icon={faCircleCheck} style={{ color:"#138500", fontSize: "20px", margin: "15px 0" }}/>

                        <h4 className="text-dark-50 text-center mt-0 font-weight-bold title">Password Changed</h4>
                    </div>

                    <div className="text-center w-100">
                        <p className="title mb-4 d-flex align-items-center justify-content-center">
                            Your password has been changed successfully <span className="text-success pl-1 d-flex align-items-center">
                        </span>
                        </p>
                    </div>
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-12 text-center">
                <p className="text-black-50">
                        Back to <a href="#" onClick={onclickBackToLogin} className="ms-1"><b>Log In</b></a>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default PasswordChanged;
